import mediaScreen from "core/checkMedia.core"
import UI from "./elements.module"

class AnchorObserverModule {
    private ui = new UI()

    constructor() { }

    toggleAnimation() {
        const entryObserver = document.querySelector("[data-observer-intercept]") as HTMLElement
        const footer = document.querySelector("footer") as HTMLElement


        const myObserver = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
            entries.forEach(entry => {
                this.ui.callToAction?.toggleAttribute("data-animate-anchor", !entry.isIntersecting)
                this.ui.callToActionAnchor?.toggleAttribute("data-animate-anchor", !entry.isIntersecting)

                if (!entry.isIntersecting) {
                    this.ui.callToActionAnchor?.classList.remove('d-none')
                    mediaScreen('max-width', '566', (e: MediaQueryListEvent) => {
                        if (e.matches) {
                            this.ui.callToAction?.classList.add('d-none')
                        }
                    })

                } else {
                    this.ui.callToAction?.classList.remove('d-none')
                }
            })
        }, {
            rootMargin: "350px 0px 0px 0px",
        })

        const formObserver = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    myObserver.unobserve(entryObserver)
                    this.ui.callToActionAnchor?.removeAttribute("data-animate-anchor")
                    this.ui.callToActionAnchor?.toggleAttribute('data-animate-none')
                } else {
                    myObserver.observe(entryObserver)
                }
            })
        })

        const footerObserver = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
            entries.forEach(entry => {

                this.ui.callToActionAnchor?.toggleAttribute("data-animate-anchor", !entry.isIntersecting)
            })
        }, {
            threshold: 1
        })

        if (this.ui.form) {
            myObserver.observe(entryObserver)
            formObserver.observe(this.ui.form)
        }

        footerObserver.observe(footer)
    }
}

export default AnchorObserverModule
